import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { RepoBusiness, RepoBusinessSearchFields, RepoBusinessTableFields } from 'src/app/models/repo-business/repo-business.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';
import { Helper } from '../../utils/helper/helper';

export class RepoBusinessListDataSource extends MatDataSource<RepoBusiness> {
  public constructor(data: RepoBusiness[], sort: MatSort, disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }


  setFilterPredicate(): void {
    this.filterPredicate = (saleHorse: RepoBusiness, filterValue: string = '') => {
      return 'address,businessName,addressLine2,stateName,countryName,postCode,suburb,website,contacts'
        .split(',')
        .some((key) => {
          return (
            saleHorse[key as keyof RepoBusiness] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              String(saleHorse[key as keyof RepoBusiness] ?? '')
            )
          );
        });
    };
  }
}
